(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIndividualDeleteController',CovidIndividualDeleteController);

    CovidIndividualDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidIndividual'];

    function CovidIndividualDeleteController($uibModalInstance, entity, CovidIndividual) {
        var vm = this;

        vm.covidIndividual = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidIndividual.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
